'use strict';

angular.module('bringgApp.directives').directive('taskCancelReasons', function (Authentication) {
	return {
		templateUrl: 'scripts/features/configuration/task_cancel_reasons/task-cancel-reasons.html',
		controller: 'TaskCancelReasonsController',
		scope: true
	};
});
